export default {"src":"/_next/static/media/meltingchip.7abd2ec8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};